module.exports = __webpack_public_path__ + "img/product2.a43126ab.png";